<template>
	<div>
		<div class="image-panel">
			<app-image
				:image="headerUrl"
				:alt="value.title"
				:cropped="isImgix ? null : cropped"
				:size="isImgix ? null : size"
			/>
			<div class="columns">
				<div class="column">
					<form-text
						placeholder="Add a description"
						field-size="is-small"
						:name="imageName"
						:has-counter="true"
						:maxlength="150"
					/>
				</div>
				<div v-if="isImgix && feature" class="column is-2">
					<div class="field focal-point">
						<vue-slider
							v-model="focalpoint"
							:min="0"
							:max="1"
							:interval="0.1"
						/>
						<small class="help">Focalpoint</small>
					</div>
				</div>
			</div>
			<div class="image-actions">
				<span class="has-text-grey" @click="onDelete">
					<dc-icon icon="trash" no-margin left-margin />
				</span>
			</div>
			<span v-if="tag" class="tag is-black is-small" v-text="tag" />
		</div>
	</div>
</template>

<script>
import fieldMixin from "@lab/utils/fieldMixin";
import FormText from "@shared/form-v1/FormText";
import AppImage from "@/components/AppImage";
import VueSlider from "vue-slider-component";
import QueryString from "query-string";
import "vue-slider-component/theme/antd.css";

export default {
	components: { FormText, AppImage, VueSlider },
	mixins: [fieldMixin],
	props: {
		onDelete: {
			type: Function,
			required: true
		},
		tag: {
			type: String,
			default: () => null
		},
		cropped: {
			type: Boolean,
			default: () => false
		},
		size: {
			type: String,
			default: () => "is-16by9"
		},
		feature: {
			type: Boolean,
			default: () => false
		}
	},
	computed: {
		imageName() {
			return `${this.name}.title`;
		},
		listingUrl() {
			return `${this.value.url}${
				this.isImgix ? `?fit=crop&w=400&h=300` : ``
			}`;
		},
		headerUrl() {
			return `${this.value.url}${
				this.isImgix
					? `?w=1344&h=500&fit=crop&fp-x=0&fp-y=${this.focalpoint}`
					: ``
			}`;
		},
		focalpoint: {
			get() {
				const focalpoint = QueryString.parse(this.value.focalpoint);
				return focalpoint["fp-y"];
			},
			set(focalY) {
				this.$store.commit("form_field_change", {
					form: this.form,
					field: `${this.name}.focalpoint`,
					value: `fp-x=0&fp-y=${focalY}`
				});
			}
		},
		notsaved() {
			return this.value.notsaved || false;
		},
		isImgix() {
			const pattern = new RegExp(/dailycare.imgix.net/g);
			return pattern.test(this.value.url);
		}
	}
};
// https://dailycare.imgix.net/URyMnvqpVbKKtGvObLbm.jpg
</script>

<style lang="scss" scoped>
.listing-example {
	max-width: 400px;
}
.image-panel {
	position: relative;
	background-color: white;
}
.image-actions {
	position: absolute;
	top: 0em;
	right: 0em;
	background-color: rgba(white, 0.5);
	padding: 5px 10px 5px 3px;
	border-bottom-left-radius: 3px;
}
.tag {
	position: absolute;
	top: 1em;
	left: 1em;
}
.field {
	margin-top: 0.5em;
	margin-bottom: 0;
}
.focal-point {
	padding-top: 0.3em;

	.help {
		margin-top: 0.7rem;
	}
}
</style>
